import { createSelector } from 'reselect';

const selectInstoreLinkCard = state => state.cardLinkOffer;

export const selectInstoreLinkCardIsLoading = createSelector(
  selectInstoreLinkCard,
  cardLinkOffer => cardLinkOffer.isLoading,
);

export const selectInstoreLinkCardIsLoaded = createSelector(
  selectInstoreLinkCard,
  cardLinkOffer => cardLinkOffer.isLoaded,
);

export const selectInstoreLinkCardResponse = createSelector(
  selectInstoreLinkCard,
  cardLinkOffer => cardLinkOffer.linkedCardResponse,
);
